import React from 'react';
export function LogoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6H3a1 1 0 100 2h3.995C7.55 8 8 7.55 8 6.995V3a1 1 0 10-2 0v3zM18 6V3a1 1 0 10-2 0v3.995C16 7.55 16.45 8 17.005 8H21a1 1 0 100-2h-3zM18 18h3a1 1 0 100-2h-3.995C16.45 16 16 16.45 16 17.005V21a1 1 0 102 0v-3zM6 18v3a1 1 0 102 0v-3.995C8 16.45 7.55 16 6.995 16H3a1 1 0 100 2h3zM12 9a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0z"
  }));
}